import { z } from 'zod'
import { PUBLIC_MAIL_DOMAINS } from '../constants/public-mail-domains.js'
import { emailSchema } from '../validators/email.validator.js'
import { uuidSchema } from '../validators/params.js'

/** A bare domain name ("example.com", "mail.example.co.uk"), lowercased. */
export const mailDomainSchema = z
  .string()
  .trim()
  .toLowerCase()
  .regex(/^(?=.{3,253}$)([a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z]{2,63}$/, 'Enter a domain like example.com')
  .refine((domain) => !PUBLIC_MAIL_DOMAINS.has(domain), {
    message: 'Public mailbox domains can only be added as individual addresses',
  })

/** The mailbox list: the newest captured test emails, or only one envelope's. */
export const testMailMessagesQuerySchema = z.object({ envelopeId: uuidSchema.optional() }).strict()

export type TestMailMessagesQuery = z.infer<typeof testMailMessagesQuerySchema>

/** Add one confirmed address, or a whole domain proven by DNS, to the test-mail allowlist. */
export const addAllowlistEntryInputSchema = z.discriminatedUnion('kind', [
  z.object({ kind: z.literal('address'), value: emailSchema }).strict(),
  z.object({ kind: z.literal('domain'), value: mailDomainSchema }).strict(),
])

export type AddAllowlistEntryInput = z.infer<typeof addAllowlistEntryInputSchema>

/** Confirming an address from the link in its confirmation email. */
export const confirmAllowlistInputSchema = z.object({ token: z.string().min(16).max(200) }).strict()

export type ConfirmAllowlistInput = z.infer<typeof confirmAllowlistInputSchema>
